<template>
    <div class="index-footer">
        <div class="f-header">
            <div class="f-header-container">
                <div class="f-text">
                    <div class="f-main">业务合作</div>
                    <div class="f-sub">如有打造数字工厂方面的需求，欢迎留言咨询，沣同科技为您量身定制解决方案！</div>
                </div>
                <div class="f-btn" @click="goYwzx">业务咨询&nbsp;→</div>
            </div>
        </div>
        <div class="f-body">
            <div class="f-body-container">
                <img src="../resource/img/foot-logo.png" />
                <div class="f-body-main">
                    <div class="f-body-item1">
                        <div class="f-menu-group">
                            <div class="f-menu-header" data-url="product">产品中心</div>
                            <div class="f-menu-body">
                                <div class="f-menu-item">机加工mes系统</div>
                                <div class="f-menu-item">铸造mes系统</div>
                                <div class="f-menu-item">热处理mes系统</div>
                                <div class="f-menu-item">工业数据采集系统</div>
                                <div class="f-menu-item">全流程质量追溯系统</div>
                                <div class="f-menu-item">仓储物流管理系统</div>
                                <div class="f-menu-item">设备管理系统</div>
                                <div class="f-menu-item">车间报工系统</div>
                                <div class="f-menu-item">电子看板</div>
                            </div>
                        </div>
                        <div class="f-menu-group">
                            <div class="f-menu-header" data-url="solution">解决方案</div>
                        </div>
                        <div class="f-menu-group">
                            <div class="f-menu-header" data-url="case">行业案例</div>
                            <div class="f-menu-body">
                                <div class="f-menu-item">机械加工行业</div>
                                <div class="f-menu-item">装备制造行业</div>
                                <div class="f-menu-item">橡胶及塑料行业</div>
                                <div class="f-menu-item">纺织服装行业</div>
                                <div class="f-menu-item">再生资源行业</div>
                            </div>
                        </div>
<!--                        <div class="f-menu-group">-->
<!--                            <div class="f-menu-header">新闻资讯</div>-->
<!--                            <div class="f-menu-body">-->
<!--                                <div class="f-menu-item">公司动态</div>-->
<!--                                <div class="f-menu-item">行业资讯</div>-->
<!--                            </div>-->
<!--                        </div>-->
                        <div class="f-menu-group">
                            <div class="f-menu-header" data-url="about">关于我们</div>
                        </div>
                    </div>
                    <div class="f-body-item2">
                        <div class="f-menu-group">
                            <div class="f-menu-header">联系我们</div>
                            <div class="f-menu-row">
                                <div class="f-menu-icon"><i class="fa fa-map-marker"></i></div>
                                <div class="f-menu-text">地址：辽宁省大连市高新园区火炬路38号三丰大厦C座2102室</div>
                            </div>
                            <div class="f-menu-row">
                                <div class="f-menu-icon"><i class="fa fa-user"></i></div>
                                <div class="f-menu-text">联系人：王经理 150 4119 0343（微信同）</div>
                            </div>
                            <div class="f-menu-row">
                                <div class="f-menu-icon"><i class="fa fa-user"></i></div>
                                <div class="f-menu-text">联系人：姜经理 132 5297 7725（微信同）</div>
                            </div>
                        </div>
                    </div>
                    <div class="f-body-item3">
                        <img src="../resource/img/qrcode.png" width="70%"/>
                        <div>企业抖音号</div>
                        <div>@大连沣同科技有限公司</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="f-footer">
            <div class="f-footer-row">
                <div class="btn-ba" @click="goBeiAn">备案号：辽ICP备2020014682号-10</div>
                <div>大连沣同科技有限公司 All Rights Reserved.</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "footerBar",
    mounted() {
        let that = this;
        $(".f-menu-header").click(function(e) {
            e.stopPropagation();
            that.clickMenu({name: $(this).attr('data-url')});
        });

        $(".f-menu-item").click(function(e) {
            e.stopPropagation();

            let $tabItem = $(this).closest('.f-menu-group').children('.f-menu-header');
            let main_url = $tabItem.attr('data-url');
            let url = $(this).attr('data-url');
            if (main_url == 'product') {
                url = 'productDetail';
            } else if (main_url == 'case') {
                url = 'case';
            }

            that.clickMenu({name: url, params: {index: $(this).index()}});
        });
    },
    methods: {
        clickMenu(opt) {
            if (!opt.name) {
                return false;
            }

            if (this.$route.fullPath === '/' + opt.name) {
                this.$hub.$emit('changeMenu', opt);
                return false;
            }

            this.$router.replace(opt);
        },
        goYwzx() {
            this.$hub.$emit('click-menu', 'contact');
        },
        goBeiAn() {
            window.open("https://beian.miit.gov.cn/");
        }
    },
}
</script>

<style scoped>
.index-footer {
    font-family: "PingFang SC-Medium", "Source Han Sans CN", sans-serif;
}

.f-header {
    background-color: #0171cb;
}

.f-header-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 45px 0;
    width: 1615px;
    margin: 0 auto;
}

.f-text {
    color: #fff;
}

.f-text .f-main {
    font-size: 30px;
    line-height: 30px;
    font-weight: bold;
    margin-bottom: 16px;
}

.f-text .f-sub {
    font-size: 22px;
    line-height: 22px;
}

.f-btn {
    background-color: #fff;
    border-radius: 25px;
    line-height: 42px;
    color: #000;
    font-size: 16px;
    padding: 0 33px;
    cursor: pointer;
    transition: all 0.3s;
}

.f-btn:hover {
    background-color: #e5e5e5;
}

.f-body {
    background-color: #051a2b;
    padding: 50px 0 75px;
}

.f-body-container {
    width: 1615px;
    margin: 0 auto;
}

.f-body-main {
    display: flex;
    color: #FFFFFF;
    margin-top: 40px;
}

.f-body-item1 {
    display: flex;
    border-right: 2px solid #697680;
    width: 50%;
}

.f-menu-group {
    flex: 1;
}

.f-menu-group .f-menu-header {
    font-size: 18px;
    line-height: 18px;
    margin-bottom: 15px;
}

.f-menu-group .f-menu-body {
    font-size: 16px;
}

.f-menu-group .f-menu-item {
    padding: 5px 0;
    cursor: pointer;
    text-decoration: underline;
    transition: all .3s;
    color: #e2e2e2;
}

.f-menu-group .f-menu-item:hover {
    color: #FFFFFF;
}

.f-body-item2 {
    width: 33%;
    padding-left: 3.8vw;
}

.f-body-item2 .f-menu-row {
    display: flex;
    align-items: flex-start;
    font-size: 16px;
    margin-bottom: 10px;
}

.f-body-item2 .f-menu-row .f-menu-icon {
    font-size: 22px;
    margin-right: 10px;
}

.f-body-item2 .f-menu-row .f-menu-text {
    margin-top: 5px;
}

.f-body-item3 {
    flex: 1;
    text-align: center;
    font-size: 16px;
}

.f-body-item3 div {
    padding: 5px 0;
}

.f-body-item3 > div:nth-child(2) {
    margin-top: 15px;
}

.f-footer {
    width: 1615px;
    padding: 40px 0;
    margin: 0 auto;
}

.f-footer-row {
    display: flex;
    font-size: 16px;
    justify-content: center;
}

.btn-ba {
    margin-right: 30px;
    cursor: pointer;
}

.btn-ba:hover {
    text-decoration: underline;
}
</style>
